import { SignInBoldImmersive } from './sign-in'

export function SignIn() {
  return <SignInBoldImmersive />
}
